import React, { useState } from "react";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import "./qbIntegration.scss";
import { FaRegAddressCard } from "react-icons/fa";
import EAButton from "../../shared/Buttons/EAButton";
import QbBasket from "./QbBasket";
import useFacility from "../../../../utils/hooks/useFacility";

interface IProps {
  onRefreshBasket: Function;
}

const QbIntegration: React.FC<IProps> = ({ onRefreshBasket }) => {
  const qbIntegrationActive = useSelector((state: State) => state.config.configuration.qbIntegrationActive);
  const qbCardName = useSelector((state: State) => state.config.configuration.qbCardName);
  const [openQbBasket, setOpenQbBasket] = useState(false);
  const basketLength = useSelector((state: State) => state.basket.basketLength);
  const facilityIds = useFacility();
  const handleOpenQbBasket = () => {
    setOpenQbBasket(true);
  };

  const handleCloseQbBasket = () => {
    setOpenQbBasket(false);
    onRefreshBasket();
  };

  if (qbIntegrationActive) {
    return (
      <>
        {facilityIds === "273" ? (
          <div className="variant-lodz qb-integration-box border shadow">
            <h5 className="no-line-height">{qbCardName}</h5>
            <EAButton
              title="Zastosuj kartę"
              startIcon={<FaRegAddressCard />}
              color="secondary"
              onClick={handleOpenQbBasket}
              disabled={basketLength === 0}
            />
          </div>
        ) : (
          <div className="qb-integration-box border shadow">
            <h5 className="no-line-height">{qbCardName}</h5>
            <EAButton
              title="Zastosuj kartę"
              startIcon={<FaRegAddressCard />}
              color="secondary"
              onClick={handleOpenQbBasket}
              disabled={basketLength === 0}
            />
          </div>
        )}

        {openQbBasket && <QbBasket onClose={handleCloseQbBasket} />}
      </>
    );
  } else {
    return <></>;
  }
};

export default QbIntegration;
